import React, { useState } from "react";
import { Camera, ImageOff } from "lucide-react";
import { EvidenceLightbox, evidenceUrl } from "./EvidenceLightbox";
import { fmtDT } from "../lib/date";

const Col = ({ title, items, zh, tone, tid, onOpen }) => (
  <div data-testid={tid} data-count={items.length} className={`rounded-lg border p-1.5 ${tone}`}>
    <p className="text-[10px] font-semibold mb-1 flex items-center gap-1"><Camera className="h-3 w-3" />{title} <span className="font-normal opacity-70">({items.length})</span></p>
    {items.length === 0 ? <div className="h-14 flex items-center justify-center text-[10px] opacity-60 gap-1"><ImageOff className="h-3.5 w-3.5" />{zh ? "暂无照片" : "No photos"}</div> : (
      <div className="grid grid-cols-3 gap-1">
        {items.map((e, i) => (
          <button key={e.fileId || i} data-testid={`${tid}-photo-${i}`} onClick={() => onOpen(e)} className="aspect-square rounded-md overflow-hidden bg-white/60 border border-black/5" title={e.by ? `${e.by} · ${fmtDT(e.at)}` : ""}>
            <img src={evidenceUrl(e.fileId)} alt={e.filename || ""} className="h-full w-full object-cover" loading="lazy" onError={(ev) => { ev.currentTarget.style.opacity = 0.2; }} />
          </button>
        ))}
      </div>
    )}
  </div>
);

/* 整改前（巡检 / PM 录入照片）| 整改后（分包提交）左右对比，点开大图可左右切换 */
export const PunchCompare = ({ punch, zh }) => {
  const [ev, setEv] = useState(null);
  const before = punch.before || [];
  const after = punch.after || [];
  const all = [...before.map((x) => ({ ...x, by: x.by || (zh ? "整改前" : "before") })), ...after];
  if (before.length === 0 && after.length === 0) return null;
  return (
    <div className="grid grid-cols-2 gap-1.5 mt-1.5" data-testid={`punch-compare-${punch.id}`}>
      <Col title={zh ? "整改前" : "Before"} items={before} zh={zh} tone="border-red-100 bg-red-50/60 text-red-800" tid={`punch-before-${punch.id}`} onOpen={setEv} />
      <Col title={zh ? "整改后（分包提交）" : "After (sub)"} items={after} zh={zh} tone="border-emerald-100 bg-emerald-50/60 text-emerald-800" tid={`punch-after-${punch.id}`} onOpen={setEv} />
      <EvidenceLightbox ev={ev} zh={zh} onClose={() => setEv(null)} items={all} onNav={setEv} />
    </div>
  );
};
